import { z } from 'zod'

/** number ｜ null Schema */
export const numberWithEmptySchema = z.union([z.number(), z.null()])

/** 日期 */
export type NumberWithEmpty = z.infer<typeof numberWithEmptySchema>
